import React, { useState } from 'react'
import { HelpCircle, MessageSquare } from 'lucide-react'
import SupportForm from './SupportForm'
import { usePermissions } from '../../hooks/usePermissions'
import { useAuth } from '../../context/AuthContext'
import { cn } from '../../utils/cn'
import { apiService } from '../../services/api'

const HelpButton = ({ variant = 'floating', className = '' }) => {
  const [showSupportForm, setShowSupportForm] = useState(false)
  const { hasPermission } = usePermissions()
  const { user } = useAuth()

  // Check if user has permission to access support
  const canAccessSupport = user?.role === 'admin' || hasPermission('can_access_support')

  const handleSupportSubmit = async (formData) => {
    try {
      console.log('Submitting support request with data:', formData)
      
      const response = await apiService.post('/support', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      console.log('Support request submitted:', response.data)
      return response.data
    } catch (error) {
      console.error('Support submission error:', error)
      console.error('Error response data:', error.response?.data)
      console.error('Error status:', error.response?.status)
      throw error
    }
  }

  // Don't render if user doesn't have permission
  if (!canAccessSupport) {
    return null
  }

  if (variant === 'floating') {
    return (
      <>
        <button
          onClick={() => setShowSupportForm(true)}
          className={cn(
            'fixed bottom-6 right-6 z-40 w-14 h-14 bg-accent-600 hover:bg-accent-700 dark:bg-accent-500 dark:hover:bg-accent-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group',
            className
          )}
          title="Need Help?"
        >
          <HelpCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
          
          {/* Tooltip */}
          <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-neutral-900 dark:bg-neutral-800 text-white px-3 py-2 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap shadow-md">
            Need Help?
            <div className="absolute top-1/2 left-full transform -translate-y-1/2 border-4 border-transparent border-l-neutral-900 dark:border-l-neutral-800"></div>
          </div>
        </button>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  if (variant === 'button') {
    return (
      <>
        <button
          onClick={() => setShowSupportForm(true)}
          className={cn(
            'inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-700 dark:text-neutral-300 bg-white dark:bg-[#221f2f] border border-neutral-200 dark:border-[#2f2b41] rounded-lg hover:bg-neutral-50 dark:hover:bg-[#2f2b41] hover:text-accent-600 dark:hover:text-accent-400 transition-colors',
            className
          )}
        >
          <MessageSquare className="w-4 h-4 mr-2" />
          Need Help?
        </button>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={() => setShowSupportForm(true)}
          className={cn(
            'p-2 text-neutral-400 hover:text-accent-600 dark:hover:text-accent-400 hover:bg-neutral-100 dark:hover:bg-[#2f2b41] rounded-lg transition-colors',
            className
          )}
          title="Need Help?"
        >
          <HelpCircle className="w-5 h-5" />
        </button>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  return null
}

export default HelpButton